module.exports = __webpack_public_path__ + "static/media/66.e8013683.png";